import { render } from "./DashboardLayout.vue?vue&type=template&id=81d11ff0&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=81d11ff0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d11ff0"],['__file',"resources/js/components/dashboard/DashboardLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81d11ff0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81d11ff0', __exports__)) {
    api.reload('81d11ff0', __exports__)
  }
  
  module.hot.accept("./DashboardLayout.vue?vue&type=template&id=81d11ff0&scoped=true", () => {
    api.rerender('81d11ff0', render)
  })

}


export default __exports__